/** vue-i18n paths for user role/status labels (value → message key) */

export const USER_ROLE_LABEL_I18N_KEY = {
  ADMIN: 'user.management.roles.admin',
  USER: 'user.management.roles.user'
};

export const USER_STATUS_LABEL_I18N_KEY = {
  ACTIVE: 'user.management.status.active',
  INACTIVE: 'user.management.status.inactive',
  BLOCKED: 'user.management.status.blocked'
};

export const USER_ROLE_OPTION_ORDER = ['ADMIN', 'USER'];
export const USER_STATUS_OPTION_ORDER = ['ACTIVE', 'INACTIVE', 'BLOCKED'];
